/**
 * 用户设备关联关系
 */
import Axios from '@/components/api/axios.js'

export default {
	/**
	 * 创建用户设备关联关系
	 * @relType ：Focus 重点关注
	 */
	addRel: (userId, relType, deviceNos, success, failure) => {
		Axios.post('/userRelDevice/addRel.do', {
			userId,
			relType,
			deviceNos
		}, success, failure);
	},
	/**
	 * 查询关联关系
	 */
	searchRel: (userId, relType, pageIndex, pageLen, success, failure) => {
		Axios.post('/userRelDevice/searchRel.do', {
			userId,
			relType,
			pageIndex,
			pageLen
		}, success, failure);
	},
	/**
	 * 移除关联关系
	 */
	removeRel: (userId, relType, deviceNos, success, failure) => {
		Axios.post('/userRelDevice/removeRel.do', {
			userId,
			relType,
			deviceNos
		}, success, failure);
	},
}
